module.exports = __webpack_public_path__ + "img/boost.b02b630a.gif";